import React, { useEffect } from "react";
import styled from "styled-components";
import { withPrefix } from "gatsby";
// import "fontsource-dm-sans";

import "../styles/global.css";
import Layout from "../components/layout";
import ProductCategory from "../components/PhoenixWrappers/productCategory";
import IntroTextWrapper from "../components/PhoenixWrappers/intro";
import CarouselWrapper from "../components/PhoenixWrappers/carousel";
import ExpandableTextWrapper from "../components/PhoenixWrappers/expandableText";
import FAQWrapper from "../components/PhoenixWrappers/faq";
import InternalLinkingBlock from "../components/internalLinkingBlock";
import DiscountWrapper from "../components/PhoenixWrappers/promoCode";
import ImageWrapper from "../components/PhoenixWrappers/partners";
import Tab from "@airasia/phoenix-components/components/Tab";
import Title from "@airasia/phoenix-components/components/Title";


const ContentWrapper = styled.div`
  margin-top: 2%;

#title-id {
     color: #f20000;
     font-weight: bold;
     font-size: 2rem;
}

#title-id-small {
     color: #f20000;
     font-weight: bold;
     font-size: 1.5rem;
     text-align: center;
     padding: 20px;
     margin-top: -40px;
}
`
;


const Index = (props) => {
  const CSData = props.pageContext.data;
  const dataHrefLang = props.pageContext.hrefLang.filter(
    (v, i, a) => a.findIndex((t) => t === v) === i
  );

  const updateLocale = (obj) => {
    window.location.href = withPrefix(obj.detail);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("uhfLocaleChange", updateLocale);
    }
  }, []);

  return (
    <Layout pageData={CSData} dataHrefLang={dataHrefLang}>


    {CSData.category && <ProductCategory categoryData={CSData.category} />}
    {CSData.headline && <IntroTextWrapper introData={CSData.headline} />}
      {CSData.carousels &&
        CSData.carousels.map((carousel, index) => {
          return (
            <CarouselWrapper carouselData={carousel} carouselIndex={index} />
          );
        })}
      {CSData.internal_linking &&
        CSData.internal_linking.map((linking) => {
          return (
            <ContentWrapper>
              <InternalLinkingBlock
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </ContentWrapper>
          );
        })}
      {CSData.promocode_linking && (
         <ContentWrapper>
           <DiscountWrapper promoData={CSData.promocode_linking} />
         </ContentWrapper>
      )}
      <br />
      {CSData.ota_logo && (
         <ContentWrapper>
           <ImageWrapper imageData={CSData.ota_logo} />
         </ContentWrapper>
      )}
      <br />
      {CSData.expandable_text_container && (
        <ContentWrapper>
          <ExpandableTextWrapper textData={CSData.expandable_text_container} />
        </ContentWrapper>
      )}
      <br />
      {CSData.faq && (
        <ContentWrapper>
          <FAQWrapper faqData={CSData.faq} />
        </ContentWrapper>
      )}

    </Layout>
  );
};

export default Index;
console.log();
